export default __webpack_public_path__ + "static/media/somethingWrongIcon.9433e6fd.svg";